import { ActivityBookingDetails } from "../components/bookings/model/ActivityBookingDetails";

export interface BookingSignal {
  ExternalActivityId: string;              // ExternalActivityId
  UserId: string;                         // Nome dell'operatore che ha eseguito l'azione
  timestamp: string;                      // Marcatore temporale dell'operazione
  newRow: ActivityBookingDetails;         // Il record completo e aggregato (OTA, TicketsSummary, etc.)
}


export enum SendBookingStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  EMAIL_SENT = 'EMAIL_SENT',
  TICKET_SAVED = 'TICKET_SAVED',
  TICKET_DOWNLOAD_STARTED = 'TICKET_DOWNLOAD_STARTED',
  TICKET_DOWNLOADING = 'TICKET_DOWNLOADING',
  TICKET_DOWNLOAD_COMPLETED = 'TICKET_DOWNLOAD_COMPLETED',
  AUDIO_GUIDE_DOWNLOAD_STARTED = 'AUDIO_GUIDE_DOWNLOAD_STARTED',
  AUDIO_GUIDE_DOWNLOADING = 'AUDIO_GUIDE_DOWNLOADING',
  AUDIO_GUIDE_DOWNLOAD_COMPLETED = 'AUDIO_GUIDE_DOWNLOAD_COMPLETED',
  AUDIO_GUIDE_DOWNLOAD_FAILED = 'AUDIO_GUIDE_DOWNLOAD_FAILED',
  SENDING_EMAIL = 'SENDING_EMAIL',
  DOWNLOAD_STARTED = 'DOWNLOAD_STARTED',
  DOWNLOAD_COMPLETED = 'DOWNLOAD_COMPLETED',
  TICKET_ERROR = 'TICKET_ERROR',
}


export const TERMINAL_PROCESS_STATUSES = new Set<string>([
  SendBookingStatus.COMPLETED,
  SendBookingStatus.EMAIL_SENT,
  SendBookingStatus.FAILED,
  SendBookingStatus.ERROR,
]);


export const PROCESS_ERROR_STATUSES = new Set<string>([
  SendBookingStatus.FAILED,
  SendBookingStatus.ERROR,
]);


export const STATUS_BADGE_CONFIG: Record<string, { label: string; color: string }> = {
  [SendBookingStatus.PROCESSING]: { label: 'Elaborazione...', color: '#2196f3' },
  [SendBookingStatus.EMAIL_SENT]: { label: 'Email inviata', color: '#4caf50' },
  [SendBookingStatus.COMPLETED]: { label: 'Completato', color: '#4caf50' },
  [SendBookingStatus.FAILED]: { label: 'Errore', color: '#f44336' },
  [SendBookingStatus.ERROR]: { label: 'Errore', color: '#f44336' },
};


// Non più necessari alias legacy, normalizzazione semplificata



// Nuova funzione: restituisce lo stato esattamente come arriva dal backend, se presente nell'enum, altrimenti PROCESSING
export function normalizeProcessStatus(status?: string): SendBookingStatus {
  if (!status) return SendBookingStatus.PROCESSING;
  const normalized = status.trim().toUpperCase();
  if (normalized in SendBookingStatus) {
    return normalized as SendBookingStatus;
  }
  return SendBookingStatus.PROCESSING;
}


export function getStatusBadgeConfig(status?: string) {
  const normalizedStatus = normalizeProcessStatus(status);
  return normalizedStatus ? STATUS_BADGE_CONFIG[normalizedStatus] ?? null : null;
}

